<template>
  <span title="项目内工单数量">{{ticketCount}}</span>
</template>

<script>
export default {
    name: 'ProjectTicketCount',

    props: ['projectId'],

    data() {
        return {
            ticketCount: -1
        };
    },

    watch: {
        projectId() {
            this.countByFilterCached();
        }
    },

    mounted() {
        this.countByFilterCached();
    },

    methods: {
        countByFilterCached() {
            var _this = this;

            if ( !window.ProjectTicketCountList ) {
                window.ProjectTicketCountList = [];
            }

            window.ProjectTicketCountList.push(this);

            clearTimeout(window.ProjectTicketCountTimeoutId);
            window.ProjectTicketCountTimeoutId = setTimeout(this._doLoad, 1000);
        },

        _doLoad() {
            var _this = this;

            if ( !window.ProjectTicketCountList ) {
                console.log("#41 window.ProjectTicketCountList=", window.ProjectTicketCountList);

                clearTimeout(window.ProjectTicketCountTimeoutId);
                window.ProjectTicketCountTimeoutId = setTimeout(this._doLoad, 1500); // 太快了？
                return;
            }

            var _filters = window.ProjectTicketCountList.map(e => {
                return { '$in_project' : e.projectId };
            });

            sdk.TicketApi().listCountByFilterCached({
                filters : _filters
            }).then(res=> {
                for ( var i=0; i < window.ProjectTicketCountList.length; i++ ) {
                    var _each = window.ProjectTicketCountList[i];
                    _each.ticketCount = res[i];
                }

                // 清理
                window.ProjectTicketCountTimeoutId = null;
                window.ProjectTicketCountList = null;
            });
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/ProjectTicketCount.vue